import React from "react";
// import logo from './logo.svg';
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { AuthDataProvider } from "./components/auth-provider";
import { Router } from "./components/router";
// import { SignalrProvider } from "./components/signalr";
import { AppProvider } from "./components/appContext/app-provider";
import { SpiRTCProvider } from "./components/spi-rtc";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";

export const App = (props: any) => {
  return (
    <BrowserRouter>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <AuthDataProvider>
          <SpiRTCProvider>
            <AppProvider>
              <Router />
            </AppProvider>
          </SpiRTCProvider>
        </AuthDataProvider>
      </MuiPickersUtilsProvider>
    </BrowserRouter>
  );
};
